import { FormList, HeaderTitle, Operation, OverItem, Thumbnails } from '@/components';
import { getMerchantList, getMerchantOver, postMerchantUpdate } from '@/api';
import { calcPrice, isSupertube, notEmptyObj, toDateTime } from '@/utils/utils';
import { Col, message, Modal, Row, Select, Table, Switch, InputNumber } from 'antd';
import React, { useState, useEffect } from 'react';
import { st_shop } from '@/utils/statetype';
import { useTable } from '@/hooks';
import MerchantEdit from './components/MerchantEdit';

const { typeObj, kindObj, recommendObj, statusObj, levelObj } = st_shop;
function ShopList({ history }) {
  const [query, setQuery] = useState({});
  const [count, setCount] = useState([]);
  const [datas, setDatas] = useState({});
  const [level, setLevel] = useState(null);
  const [editRow, setEditRow] = useState({});
  const [editingValue, setEditingValue] = useState(null);
  const [visible, setVisible] = useState(false);

  const columns = {
    id: '店铺编号',
    title: '店铺名称',
    shopIcon: {
      title: '店铺LOGO',
      render: e => <Thumbnails images={[e]} center />,
    },
    type: {
      title: '店铺类型',
      render: e => typeObj[e] || '-',
    },
    kind: {
      title: '商家身份',
      render: e => kindObj[e] || '-',
    },
    NOINDEX_isRecommend: {
      title: '热门推荐',
      render: (e) => (
        <Switch
          checked={e.isRecommend === 1}
          checkedChildren='已推荐'
          unCheckedChildren='未推荐'
          onChange={(check) => handleUpdateIsrRecommend(e.id, check ? 1 : 0)}
        />
      ),
    },
    shopLevel: {
      title: '店铺身份',
      render: e => levelObj[e] || '-',
    },
    NOINDEX_category: {
      title: '店铺分类',
      render: e =>
        `${e.Category1 ? e.Category1.name ?? '' : ''}${e.Category2 ? `>${e.Category2.name ?? ''}` : ''
        }`,
    },
    recommendMerchantId: '上级店铺编号',
    totalAmount: {
      title: '店铺余额',
      render: e => calcPrice(e),
    },
    firmName: '企业名称',
    creditCode: '社会信用代码',
    name: '法人姓名',
    address: '详细地址',
    status: {
      title: '店铺状态',
      render: e => statusObj[e],
    },
    NOINDEX_sort: {
      width: 120,
      title: '排序',
      render: (record) => (
        record.id === editRow.id ? (
          <InputNumber
            min={0}
            max={10000}
            value={editingValue}
            onChange={setEditingValue}
            onPressEnter={() => handleUpdateSort(record.id)}
            autoFocus
            style={{ width: '100%' }}
          />
        ) : (
          <span
            style={{
              padding: '10px 10px',
              background: '#07C160',
              borderRadius: '4px',
              cursor: 'pointer',
              color: "#fff"
            }}
            onClick={() => { setEditRow(record); setEditingValue(record.sort) }}
          >
            {record.sort}
          </span>

        )
      )
    },
    createdAt: {
      title: '开通时间',
      render: e => toDateTime(e),
    },
    NOINDEX_operation: {
      title: '操作',
      fixed: 'right',
      render: e => (
        <Operation
          disabled={{
            identity: e.shopLevel !== 11 || e.status !== 2,
          }}
          hideMenu={{
            identity: !isSupertube(),
          }}
          listData={{
            select: () => history.push(`/shop/list/detail?i=${e.id}`),
            identity: () => setDatas(e),
            update: () => {
              const { ...prop } = e;
              setVisible(true);
              setDatas({
                ...prop,
              });
            },
          }}
        />
      ),
    },
  };

  const { tableProps, flagFn } = useTable({
    columns,
    API: getMerchantList,
    isInit: false,
    params: {
      query,
    },
  });

  const formData = [
    {
      id: 'id',
      label: '店铺编号',
    },
    {
      id: 'title',
      label: '店铺名称',
    },
    {
      id: 'contact',
      label: '手机号码',
    },
    {
      id: 'status',
      label: '店铺状态',
      type: 'select',
      selects: statusObj,
    },
    {
      id: 'isRecommend',
      label: '是否推荐',
      type: 'select',
      selects: recommendObj,
    },
    {
      id: 'kind',
      label: '商家身份',
      type: 'select',
      selects: kindObj,
    },
    {
      id: 'applyTime',
      label: '开通时间',
      type: 'rangeTime',
    },
  ];

  useEffect(() => {
    getMerchantOver().then(res => {
      const countData = [['总店铺', res.all], ...(res.category2 || []).map(i => [i.name, i.count])];
      setCount(countData);
    });
  }, []);

  const changeQuery = (value = {}) => {
    const { applyTime, ...props } = value;
    const [start, end] = applyTime || [];
    const q = {
      ...props,
      ...(applyTime && {
        applyStartTime: toDateTime(start),
        applyEndTime: toDateTime(end),
      }),
    };
    setQuery(q);
    flagFn(true);
  };

  const handleUpdateIsrRecommend = (id, isRecommend) => {
    const data = { id: id, isRecommend: isRecommend }
    postMerchantUpdate({
      body: data,
    }).then(() => {
      message.success('操作成功');
      flagFn();
      setDatas({});
      setLevel(null);
    });
  };

  const handleUpdateSort = (id) => {
    console.log("handleUpdateSort", id, editingValue)
    setEditRow({})
    const data = { id: id, sort: editingValue }
    postMerchantUpdate({
      body: data,
    }).then(() => {
      message.success('操作成功');
      flagFn();
      setDatas({});
      setLevel(null);
    });
  };


  return (
    <>
      <HeaderTitle />
      <OverItem datas={count} width={'20%'} />
      <FormList formData={formData} changeQuery={changeQuery} />
      <Table {...tableProps} />
      <Modal
        visible={notEmptyObj(datas)}
        title="店铺升级"
        onCancel={() => {
          setDatas({});
          setLevel(null);
        }}
        onOk={() => {
          if (!level) {
            return message.warning('请设置新的店铺身份');
          }
          postMerchantUpdate({
            body: {
              id: datas.id,
              shopLevel: level,
            },
          }).then(() => {
            message.success('操作成功');
            flagFn();
            setDatas({});
            setLevel(null);
          });
        }}
      >
        <Row align="middle" justify="center">
          <Col>店铺身份：</Col>
          <Select
            placeholder="请设置店铺身份"
            onChange={e => setLevel(Number(e))}
            style={{ width: '220px', margin: '0 20px 0 10px' }}
          >
            {Object.keys(levelObj).map(i => (
              <Select.Option key={i} value={i} disabled={datas.shopLevel >= Number(i)}>
                {levelObj[i]}
              </Select.Option>
            ))}
          </Select>
        </Row>
      </Modal>
      <MerchantEdit
        data={datas}
        visible={visible}
        onChange={res => {
          if (res) flagFn();
          setVisible(false);
          setDatas({});
        }}
      />
    </>
  );
}

export default ShopList;
